import { anyReferencesToNodeSelector } from "@skilitics/nautilus-core-designer-data";

import { useNautilusSelector } from "./shared.ts";

export const useAnyReferencesToNode = () => useNautilusSelector(anyReferencesToNodeSelector);
